module.exports = __webpack_public_path__ + "img/FooterPermataKeluarga.6181ce96.png";